import classNames from 'classnames'
import React from 'react'
import SwiperCore, { Navigation, SwiperOptions } from 'swiper'
import 'swiper/css'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useMobile } from '../../hook/useMobile'
import Button from '../Button'
import Icons, { IconType } from '../Icons'
import SingleImage, { SingleImageProps } from '../single-image/single-image'
import styles from './article-carousel.module.scss'

SwiperCore.use([Navigation])
export interface Props {
  images: SingleImageProps[];
}

const ArticleCarousel = (props: Props) => {
  const { images } = props;
  const navigationPrevRef = React.useRef(null)
  const navigationNextRef = React.useRef(null)
  const isMobile = useMobile()
  const spaceBetweenSlide = isMobile ? 10 : 20

  const swiperOption: SwiperOptions = {
    spaceBetween: spaceBetweenSlide,
    centeredSlides: true,
    slidesPerView: 'auto',
    loop: true,
    navigation: {
      prevEl: navigationPrevRef.current,
      nextEl: navigationNextRef.current,
    },
    
  }
  const renderNavigation = () => {
    return (
      <>
        <Button
          ref={navigationPrevRef}
          className={classNames(
            styles.sliderNavigate,
            styles.sliderNavigatePrev
          )}
          type="olive"
          icon={<Icons type={IconType.Left} />}
          size="large"
        />
        <Button
          ref={navigationNextRef}
          className={classNames(
            styles.sliderNavigate,
            styles.sliderNavigateNext
          )}
          type="olive"
          icon={<Icons type={IconType.Right} />}
          size="large"
        />
      </>
    )
  }
  const renderSlide = (slide: SingleImageProps) => {
    return (
      <SwiperSlide key={`slider_image_key_${slide.imageUrl}`}>
        <SingleImage
          tag={slide.tag}
          tagPosition="bottom"
          imageUrl={slide.imageUrl}
          imageHref={slide.imageHref}
          colorless={true}
          ratio={[874, 520]}
        />
      </SwiperSlide>
    )
  }
  return (
    <div className={styles.articleCarousel}>
      <div className={styles.articleSliderContainer}>
        <Swiper className={styles.articleSwiperContainer} {...swiperOption}>
          {images.map((slide: SingleImageProps) => renderSlide(slide))}
        </Swiper>
        {renderNavigation()}
      </div>
    </div>
  );
}

export default ArticleCarousel
